export class LocationService {
  static addressLineShort(location) {
    if (!location?.city) {
      return '';
    }

    return `${location.city}, ${location.state} ${location.zipcode}`;
  }
  static getGmapsSearch(event) {
    if (!event) {
      return null;
    }
    const gmapsSearch = 'https://www.google.com/maps/search/?api=1&query=';

    const getFormattedAddress = (address) => address.replaceAll(/\s+/g, '+');

    if (event?.isLocationOverride) {
      return gmapsSearch + getFormattedAddress(event.locationOverrideAddress);
    }

    const venue = event.venue;
    const location = event.location;

    if (venue?.isVenueAddressOverridden) {
      const fullAddress = `${venue.address} ${this.addressLineShort(venue)}`;
      return gmapsSearch + getFormattedAddress(fullAddress);
    }

    if (location) {
      const fullAddress = `${location.address} ${this.addressLineShort(location)}`;
      return gmapsSearch + getFormattedAddress(fullAddress);
    }

    return null;
  }
}
